import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  FIRST_LOGIN_TIME_AFTER_REGISTRATION_KEY,
  SECOND_LOGIN_TIME_AFTER_REGISTRATION_KEY,
  THIRD_LOGIN_TIME_AFTER_REGISTRATION_KEY,
} from "hooks/useCollectPhonePopupTrigger";

// Types
import { AuthState, ChangeBooleanValues, ChangeStringValues } from "types/Auth";
import {
  removeLocalStorageItem,
  setLocalStorageItem,
} from "utils/localStorage";

const initialState: AuthState = {
  isAuthenticated: null,
  login: "",
  password: "",
  currencyCode: "",
  ageAgreement: false,
  policyAgreement: false,
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    changeStringField(state, action: PayloadAction<ChangeStringValues>) {
      const { field, value } = action.payload;
      state[field] = value;
    },
    changeBooleanname(state, action: PayloadAction<ChangeBooleanValues>) {
      const { field, value } = action.payload;
      state[field] = value;
    },
    setCurrency(state, action: PayloadAction<string>) {
      state.currencyCode = action.payload;
    },
    login(state) {
      state.isAuthenticated = true;
    },
    logout(state) {
      state.isAuthenticated = false;
      setLocalStorageItem("phoneTriggerStatus", "1");
      removeLocalStorageItem(FIRST_LOGIN_TIME_AFTER_REGISTRATION_KEY);
      removeLocalStorageItem(SECOND_LOGIN_TIME_AFTER_REGISTRATION_KEY);
      removeLocalStorageItem(THIRD_LOGIN_TIME_AFTER_REGISTRATION_KEY);
    },
    clearState(state) {
      state.login = "";
      state.password = "";
      state.currencyCode = null;
      state.ageAgreement = false;
      state.policyAgreement = false;
    },
  },
});

export const {
  changeBooleanname,
  changeStringField,
  setCurrency,
  clearState,
  login,
  logout,
} = authSlice.actions;

export default authSlice.reducer;
